// src/components/sidebar/messages.jsx
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faUser,
	faCheckCircle,
	faExclamationTriangle,
	faTimes,
	faTimesCircle,
	faQuestionCircle,
	faBomb,
	faLock,
	faGaugeHigh,
} from "@fortawesome/free-solid-svg-icons";
import reqLog from "../../../../services/reqMultiTenant/reqLog";
import LibDateTime from "../../../../util/libDateTime";

const statusMap = {
	ERRO: { icon: faTimesCircle, color: "text-red-500" },
	// Exceção que escapou da rota e chegou no middleware global do servidor
	CRASH: { icon: faBomb, color: "text-red-600" },
	// Token recusado pelo JWT: não é falha do servidor, é acesso sem credencial
	AUTH: { icon: faLock, color: "text-yellow-500" },
	// Rota que passou do tempo limite do middleware de performance
	PERFORMANCE_ALERT: { icon: faGaugeHigh, color: "text-blue-500" },
	WARNING: { icon: faExclamationTriangle, color: "text-yellow-500" },
	SUCCESS: { icon: faCheckCircle, color: "text-green-500" },
	NEW: { icon: faCheckCircle, color: "text-green-500" },
	DEFAULT: { icon: faQuestionCircle, color: "text-gray-400" },
};

const MessageList = ({ logData, setLogData }) => {
	const handleDelete = async (id) => {
		try {
			const response = await reqLog.update(false, id);
			setLogData((prev) => prev.filter((msg) => msg.uuid_log !== id));
		} catch (error) {
			console.log(error.message);
		}
	};

	return (
		<div className="h-full flex flex-col bg-white">
			{/* Cabeçalho */}
			<div className="px-4 py-2 border-b border-gray-200">
				<h2 className="text-lg font-semibold text-gray-800">Notificações</h2>
			</div>

			{/* Lista */}
			<ul className="flex-1 overflow-y-auto divide-y divide-gray-200">
				{logData?.map((msg) => {
					// Fallback seguro
					const safeStatus = statusMap[msg.status] || statusMap.DEFAULT;

					return (
						<li
							key={msg.uuid_log}
							className="group flex items-start gap-3 px-4 py-3 hover:bg-blue-500 cursor-pointer transition"
						>
							{/* Ícone com fallback */}
							<FontAwesomeIcon
								icon={safeStatus.icon}
								className={`w-5 h-5 mt-1 ${safeStatus.color ?? ""}`}
							/>

							<div className="flex-1">
								<p className="text-sm font-medium text-gray-800 group-hover:text-white">{msg.status}</p>

								<p className="text-sm font-medium text-gray-800 group-hover:text-white">
									{msg.nome} - ID {msg.id_empresa}
								</p>

								<p className="text-xs text-gray-600 group-hover:text-gray-200">{msg.descricao}</p>

								{msg.obs && (
									<p className="text-xs text-gray-600 group-hover:text-gray-200">Obs: {msg.obs}</p>
								)}

								<p className="text-xs text-gray-600 group-hover:text-gray-200">
									{LibDateTime.formatDateInTimeZone(msg.data)}
								</p>
							</div>

							<button
								onClick={(e) => {
									e.stopPropagation();
									handleDelete(msg.uuid_log);
								}}
								className="text-gray-400 hover:text-red-500 transition"
								title="Excluir"
							>
								<FontAwesomeIcon icon={faTimes} className="w-4 h-4" />
							</button>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default MessageList;
